import getColorInCyanToYellowRange from './getColorInCyanToYellowRange.js';
import NBA_TEAM_LIST from '../data/NBA_TEAM_LIST.js';

const PERIOD_COLORS = {
  1: 'red',
  2: 'green',
  3: 'cyan',
  4: 'yellow',
};

// currently groups by division in the same color
const OPPOSING_TEAM_COLORS = {};
NBA_TEAM_LIST.forEach((team) => {
  OPPOSING_TEAM_COLORS[team.abbreviation] = team.color;
});

const SHOT_COLOR_GENERATORS = {
  // All yellow
  ALL_YELLOW: () => 'yellow',
  // Three pointer number
  SHOT_NUMBER: shot => getColorInCyanToYellowRange(1, 2974, shot["3-Pointer Number"]),

  // Game date
  GAME_DATE_CY: shot => getColorInCyanToYellowRange(20091030, 20211214, shot.GAME_DATE),
  
  // Shot distance
  SHOT_DISTANCE: shot => getColorInCyanToYellowRange(22, 40, shot.SHOT_DISTANCE), // bucketing better because of outliers
  
  // X position
  LOC_X_CY: shot => getColorInCyanToYellowRange(-250, 250, shot.LOC_X),
  
  // Y position
  LOC_Y_CY: shot => getColorInCyanToYellowRange(-52, 448, shot.LOC_Y),

  // Home vs away
  HOME_OR_AWAY: shot => shot.HTM === 'GSW' ? 'blue' : 'yellow',

  // Opposing team city
  OPPONENT: (shot) => {
    if (shot.HTM === 'GSW') {
      return OPPOSING_TEAM_COLORS[shot.VTM];  
    } else {
      return OPPOSING_TEAM_COLORS[shot.HTM];
    }
    
  },

  // Time remaining in game
  TIME_LEFT_CY: (shot) => {
    const secondsLeftInGame = 12 * 60 * (4 - shot.PERIOD) + 60 * shot.MINUTES_REMAINING + shot.SECONDS_REMAINING;
    return getColorInCyanToYellowRange(0, 48 * 60, secondsLeftInGame);
  },

  // Quarter
  QUARTER: (shot) => {
    return PERIOD_COLORS[shot.PERIOD];
  },

  // Other possible options: based on nft data. special moment, #threes in game

};

export default SHOT_COLOR_GENERATORS;